export default "__VITE_ASSET__DXRq$MN6__"